<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <div v-for="(item, index) in tiles" v-bind:key="index">
        <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
          :icon="item.icon"
          :value="$t(item.title)"
          v-if="!item.vif || item.vif.call(this)"
        >
          <template slot="actions">
            <div class="d-flex justify-center flex-wrap">
              <v-btn
                v-for="(button, index) in item.buttons"
                v-bind:key="index"
                text
                color="primary"
                @click="button.action.call(this)"
              >
                {{ $t(button.title) }}
              </v-btn>
            </div>
          </template>
        </material-stats-card>
      </div>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";
export default {
  data() {
    return {
      broker: null,
      tiles: [
        {
          title: "views.portal.theme_settings",
          icon: "palette",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "themeSettings",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.contacts",
          icon: "email",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "portalContacts",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.sidebar_items",
          icon: "vertical_split",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "sidebarItems",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "components.themesettings.banner",
          icon: "view_carousel",
          buttons: [
            {
              title: "views.portal.configure",
              action: () => {
                this.$router.push({
                  name: "portalNews",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.pages",
          icon: "file_copy",
          buttons: [
            {
              title: "views.portal.manage_content",
              action: () => {
                this.$router.push({
                  name: "portalPages",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.notifications",
          icon: "announcement",
          buttons: [
            {
              title: "views.portal.configure",
              action: () => {
                this.$router.push({
                  name: "portalNotifications",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.download_center",
          icon: "get_app",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "downloadCenter",
                  params: { planId: this.selectedPlan.Id, edit: true },
                });
              },
            },
          ],
        },
        {
          title: "views.portal.benefit_cards",
          icon: "credit_card",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "benefitCards",
                  params: { planId: this.selectedPlan.Id, edit: true, cms:"old" },
                });
              },
            },
          ],
        },
        {
          title: "views.portal.drugs_and_provider_index",
          icon: "local_hospital",
          buttons: [
            {
              title: "views.portal.drug_list",
              action: () => {
                this.$router.push({
                  name: "drugs",
                  params: { planId: this.selectedPlan.Id, cms:"old" }
                });
              },
            },
            {
              title: "views.portal.provider_list",
              action: () => {
                this.$router.push({
                  name: "providers",
                  params: { planId: this.selectedPlan.Id, cms:"old" }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.suggestions_center",
          icon: "forum",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                // this.$router.push({
                //   name: "downloadCenter",
                //   params: { edit: true }
                // });
              },
            },
          ],
        },
        {
          title: "globals.coverage",
          icon: "security",
          buttons: [
            {
              title: "views.portal.manage_content",
              action: () => {
                this.$router.push({
                  name: "portalCoverage",
                  params: { planId: this.selectedPlan.Id }
                });
              },
            },
          ],
        },
        {
          title: "views.portal.welcome_kit",
          icon: "mail",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "welcomeKit",
                  params: { planId: this.selectedPlan.Id }
                });
              }
            }
          ]
        },
        // {
        //   title: "views.portal.images",
        //   icon: "square_foot",
        //   buttons: [
        //     {
        //       title: "components.vuematerialdashboard.core.drawer.view_edit",
        //       action: () => {
        //         this.$router.push({
        //           name: "images"
        //         });
        //       }
        //     }
        //   ]
        // }
      ],
    };
  },
  mixins: [planSetter, portalPermission],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
};
</script>

<style></style>
